const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5001';

const headers = { 'Content-Type': 'application/json' };

// ─── Audit ─────────────────────────────────────────────────
export async function logAudit({ user, role, action, detail = '', sources = [], resultCount = 0 }) {
  try {
    const r = await fetch(`${BACKEND_URL}/api/audit/log`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ user, role, action, detail, sources, resultCount })
    });
    return r.ok ? r.json() : null;
  } catch (e) {
    console.warn('audit log failed:', e.message);
    return null;
  }
}

export async function fetchAudit({ user, action, limit = 200 } = {}) {
  const qs = new URLSearchParams();
  if (user) qs.set('user', user);
  if (action) qs.set('action', action);
  qs.set('limit', String(limit));
  const r = await fetch(`${BACKEND_URL}/api/audit/list?${qs}`);
  if (!r.ok) throw new Error(`audit list ${r.status}`);
  const j = await r.json();
  return j.data || [];
}

// ─── Annotations ───────────────────────────────────────────
export async function fetchAnnotations() {
  const r = await fetch(`${BACKEND_URL}/api/annotations`);
  if (!r.ok) throw new Error(`annotations ${r.status}`);
  const j = await r.json();
  return j.data || [];
}

export async function createAnnotation(payload) {
  const r = await fetch(`${BACKEND_URL}/api/annotations`, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload)
  });
  if (!r.ok) throw new Error(`create annotation ${r.status}`);
  const j = await r.json();
  return j.data;
}

export async function updateAnnotation(id, patch) {
  const r = await fetch(`${BACKEND_URL}/api/annotations/${id}`, {
    method: 'PUT',
    headers,
    body: JSON.stringify(patch)
  });
  return r.ok;
}

export async function deleteAnnotation(id) {
  const r = await fetch(`${BACKEND_URL}/api/annotations/${id}`, { method: 'DELETE' });
  return r.ok;
}

// ─── Onboarded Layers ──────────────────────────────────────
export async function fetchOnboardedLayers() {
  const r = await fetch(`${BACKEND_URL}/api/onboarded-layers`);
  if (!r.ok) return [];
  const j = await r.json();
  return j.data || [];
}

export async function testOnboardingConnection(source_url) {
  const r = await fetch(`${BACKEND_URL}/api/onboarded-layers/test-connection`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ source_url })
  });
  if (!r.ok) throw new Error(`test connection ${r.status}`);
  return r.json();
}

export async function publishOnboardedLayer(payload) {
  const r = await fetch(`${BACKEND_URL}/api/onboarded-layers`, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload)
  });
  if (!r.ok) throw new Error(`publish layer ${r.status}`);
  const j = await r.json();
  return j.data;
}

// ─── Connected Sources ─────────────────────────────────────
export async function fetchConnectedSources() {
  const r = await fetch(`${BACKEND_URL}/api/connected-sources`);
  if (!r.ok) return [];
  const j = await r.json();
  return j.data || [];
}

export async function fetchSourceFiles(id) {
  const r = await fetch(`${BACKEND_URL}/api/connected-sources/${id}/files`);
  if (!r.ok) return [];
  const j = await r.json();
  return j.data || [];
}
